import { render } from "./ImpressumComponent.vue?vue&type=template&id=0a41c4fe"
import script from "./ImpressumComponent.vue?vue&type=script&lang=js"
export * from "./ImpressumComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__